function createIApp() {
  return {
    modalInsu: null,
    token: null,
    context: "cart",
    element: null,
    collapsed: true,
    productId: null,
    variantId: null,
    insurance: {
      rut: null,
      rut_type: null,
      cp: null,
      fnac: null,
      title: null,
      desc: null,
      coverage: null,
      price: 0,
    },
    url: {
      getCollection: "https://dd4256vxmg.execute-api.us-west-2.amazonaws.com/prod/getByCollectionId",
      getByPrice: "https://mbvx45p8lh.execute-api.us-west-2.amazonaws.com/prod/getCare",
      addCart: "cart/add.js",
      img: {
        check:
          "https://cdn.shopify.com/s/files/1/0713/2368/1056/files/tick_grey.svg?v=1711632475",
      },
      createLog: "https://z7aoupsfv1.execute-api.us-west-2.amazonaws.com/prod/createLog"
    },
    observeCartChanges : async function() {
      const cartObserver = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
          const isCartChangeRequest = /\/cart\//.test(entry.name);
          if (isValidRequestType && isCartChangeRequest) {
            console.log('entro al if observeCartChanges');
          }
        });
      });
      cartObserver.observe({ entryTypes: ["resource"] });
    },
    init: function (product_id, product_el) {
      createIApp.modalCoverage = new bootstrap.Modal('#modalCoverage',{});
      this.element = product_el;
      this.productId = product_id;
      this.variantId = product_el.dataset.variantId;
      this.context = product_el?.dataset?.context;
      this.events();
      this.loadInsurances(product_id, product_el);
      $('#fnac, #rut').on('blur', function (){
        $('.checkValidity').hide();
      });
      $('#rut').on('input', function () {
         $('.checkRut').hide();
         $('#rut').css('border','1px solid #DEE2E5');
      });
      $('.coverage-trigger-js').fadeIn()
    },
    openInsurance: async function (target) {
      console.log("target ==>", target);
      this.insurance = {
        ...this.insurance,
        price: target.dataset.price,
        title: target.dataset.title,
        desc: target.dataset.desc,
        coverage: target.dataset.coverage,
      };
  console.log("test ==>", this.insurance);
      $('.form-control-type').html(this.insurance.title);
      $('.form-control-price').html('$' + this.insurance.price)

      this.element.dataset.active = false;

      // Obtener datos del cliente
      var scriptElement = $("#web-pixels-manager-setup");
      var scriptContent = scriptElement.html();
      var match = scriptContent.match(/"customer":\s*({[^}]*})/);
      var userEmail = null;
      var userFirstName = null;
      var userLastName = null;
      if (match) {
        var customerInfo = match[1];
        try {
          customerData = JSON.parse(customerInfo);
          userEmail = customerData.email;
          userFirstName = customerData.firstName;
          userLastName = customerData.lastName;
        } catch (error) {
          console.error("Error al analizar JSON del cliente:", error);
        }
      }
      const objeto = {
        email: userEmail !== null ? `${userEmail}` : null,
        full_name:
          userEmail !== null ? `${userFirstName} ${userLastName}` : null,
        product_id: this.productId,
        insurance: this.insurance.title + " " + this.insurance.price,
        token: this.token,
      };
      axios
        .post(this.url.createLog, objeto)
        .then((response) => {
          console.log("Log registrado:", response.data);
        })
        .catch((error) => {
          console.error("Error al registrar el log:", error);
        });
      // Gatillamos envio automático
      $('.btn-submit-insurance').trigger('click');

      $('.btn-submit-insurance').on('click', function () {
        $('.btn-add-coverage').addClass('btn-add-coverage-hover');
        $('svg.loading-save-coverage').show();
      });
    },
    setDataInsu: function (e) {
      const data = $(this.element).find(".insurance_add_form input").serializeArray();
      console.log('setDataInsu data:', data)
      
      const insurance_data = Object.values(data).reduce((acc, item) => {
        acc[item.name] = item.value;
        return acc;
      }, {});
      console.log('setDataInsu insurance_data:', insurance_data)

      this.insurance = {
        ...this.insurance,
        ...insurance_data,
      };

      console.log('setDataInsu this.insurance:', this.insurance)

      if (this.context === "cart") {
        const $addToCartForm = $(this.element)
          .closest(".insurance_form")
          .find("input");
        const formData = $addToCartForm.serializeArray();
        console.log('setDataInsu formData:', formData);
        this.getInsuranceData(formData).then((data) => {
          console.log("data log ==>", data);
          this.addToCart(data).then((r) => {
            console.log("CHECK ----->", data, r)
            window.location.reload()
          });
        });
      }
    },
    resetModal: function () {
      $("input[type=checkbox]").prop("checked", false);
      $('input[type=radio][name="insurance"]').prop("checked", false);
      $(".insurance_content").removeClass("selected");
      $("#insurance_title,#insurance_price,#customer-name").val("");
    },
    checkValidity: function() {
      const fnac = $('#fnac').val();
      const rut = $('#rut').val();
    
      if(fnac === '' || rut === ''){
          $('.checkValidity').show();
          return false
      } else {
          $('.checkValidity').hide();
          return true
      }
    },
    validateRut: function (rutCompleto) {
        rutCompleto = rutCompleto.replace("‐","-");
        if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) return false;
        var [rut, digv] = rutCompleto.split('-');
        digv = digv.toUpperCase() === 'K' ? 'k' : digv;
        
        var M=0,S=1;
        for(;rut;rut=Math.floor(rut/10)) S=(S+rut%10*(9-M++%6))%11;
        return (S ? S-1 : 'k') == digv;
    },
    generarToken: function (length) {
      let result = "";
      const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    handleize: function (str) {
      return str
        .toLowerCase()
        .replace(/[^\w\u00C0-\u024f]+/g, "-")
        .replace(/^-+|-+$/g, "")
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, "");
    },
    loadInsurances: async function (productId, product_el) {
      if (!product_el) {
        return;
      }
      
      const precioTexto = String(product_el.dataset.price);
      const formattedPrice = Number(precioTexto.replace(/\./g, ''));

      const idSbu = product_el.dataset.category === 'Tablets' ? 3 : 1;
      const tags = document.querySelector('.insurance_form input[name="tags"]').value.split(',');
      const brandTag = tags.find(tag => tag.startsWith("Marca_"));
      let idBrand;
      
      if (brandTag) {
          const brand = brandTag.replace("Marca_", "");
          idBrand = brand.toUpperCase() === 'APPLE' ? 1 : 2
          console.log("Marca encontrada:", brand);
      } else {
          console.log("No se encontró la marca");
      }

      axios
        .post(this.url.getByPrice, {
          id_brand: idBrand,
          id_sbu: idSbu,
          product_price: formattedPrice
        })
        .then((response) => {
          let seguros = response.data.data;
          console.log('seguros ---->', seguros, Object.entries(seguros))
           for (const [key, seguro] of Object.entries(seguros)) {
             const handle = this.handleize(seguro.product);
             const insurance_el = this.element.querySelector(
               `.insurance[data-handle="${handle}"]`
             );
             if (insurance_el) {
               const price = seguro.price.toLocaleString("es-CL", {
                 style: "currency",
                 currency: "CLP",
               });

               const precioTexto = String(seguro.price);
               const formattedPrice = Number(precioTexto.replace(/\./g, ''));
               const precioFormateado = Number(seguro.price).toLocaleString("es-CL");

               console.log("precioFormateado =>", precioFormateado);
 
               insurance_el.dataset.price = formattedPrice;
               insurance_el.dataset.id_product = seguro.id_product;
               insurance_el.querySelector(".insurance-description").innerText = seguro.cover;
               //insurance_el.querySelector("strong.mpayment").innerText = seguro.monthly_payment;
               insurance_el.querySelector(".insurance_content ul li:nth-child(1)").innerText = seguro.duration;
               insurance_el.querySelector(".insurance_content ul li:nth-child(2)").innerText = seguro.process;
               insurance_el.querySelector(".insurance_content ul li:nth-child(3) strong").innerText = seguro.deductible;
               insurance_el.querySelector(".insurance-title").innerText = `$${precioFormateado}`;
             }
           }

          product_el.removeAttribute("hidden");
        })
        .catch((error) => {
          console.error("Error al intentar obtener los servicios: ", error);
        });
    },
    getValueByName: function (formData, name) {
      const field = formData.find((item) => item.name === name);
      return field ? field.value : null;
    },
    getInsuranceData: async function (formData) {
      const insuranceData = {
        plan: this.insurance.title,
        price: this.insurance.price,
        formData: formData,
      };

      return axios
        .post(this.url.getCollection, insuranceData)
        .then((response) => {
          const insurance_id = response.data.data.variant_id;
          const productData = `${this.productId}-${insurance_id}-${this.variantId} | ${this.insurance.title}`;
        console.log("test new ==>", this.insurance);
          return {
            items: [
              {
                id: insurance_id,
                quantity: 1,
                properties: {
                  _VariantId: this.variantId,
                  _Insurance: productData,
                  _InsuranceTitle: this.insurance.title,
                  _InsuranceDesc: this.insurance.desc,
                  _InsuranceCoverage: this.insurance.coverage,
                  _insurance_rut: this.insurance.rut,
                  _insurance_rut_type: this.insurance.rut_type,
                  _insurance_cp: this.insurance.cp,
                  _insurance_fnac: this.insurance.fnac,
                  _insurance_token: this.token,
                },
              },
            ],
            attributes: {
              Insurance: productData,
              insurance_rut: this.insurance.rut,
              insurance_rut_type: this.insurance.rut_type,
              insurance_cp: this.insurance.cp,
              insurance_fnac: this.insurance.fnac,
              insurance_token: this.token,
            },
          };
        });
    },
    events: function () {
      $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
        success: (cartData) => {
          console.log("Atributos del carrito:", cartData.attributes);
          if (cartData.attributes.insurance_token === undefined) {
            this.token = this.generarToken(20);
          } else {
            this.token = cartData.attributes.insurance_token;
          }
        },
        error: function (xhr, status, error) {
          console.error("Error al obtener datos del carrito:", error);
        },
      });

      const fnac_inputs = document.querySelectorAll(".fnac_input");
      if (fnac_inputs) {
        fnac_inputs.forEach((fnac) => {
          fnac.addEventListener("blur", (e) => {
            var selectedDate = new Date(e.target.value);
            var today = new Date();
            var minDate = new Date(
              today.getFullYear() - 18,
              today.getMonth(),
              today.getDate()
            );

            if (selectedDate > minDate) {
              alert("Debes tener al menos 18 años.");
              e.target.value = "";
              return false;
            }

            this.insurance.fnac = e.target.value;
          });
        });
      }

      const rut_type_inputs = document.querySelectorAll(".fnac_input");
      if (rut_type_inputs) {
        rut_type_inputs.forEach((rut_type) => {
          rut_type.addEventListener("change", (e) => {
            this.insurance.rut_type = e.target.value;
          });
        });
      }

      const add_insurance_ctas = this.element.querySelectorAll(".add_insurance");
      if (add_insurance_ctas) {
        add_insurance_ctas.forEach((add_insurance) => {
          add_insurance.addEventListener("click", (e) => {
            const product_wrapper = add_insurance.closest(".insurance");            
            this.openInsurance(product_wrapper);
          });
        });
      }

      const close_insurance_cta = this.element.querySelector(
        ".btn-close-insurance"
      );
      if (close_insurance_cta) {
        close_insurance_cta.addEventListener("click", (e) => {
          this.element.dataset.active = false;
        });
      }

      const submit_insurance_cta = this.element.querySelector(".btn-submit-insurance");
      if (submit_insurance_cta) {
        submit_insurance_cta.addEventListener("click", (e) => {


          this.setDataInsu(submit_insurance_cta);
          this.element.dataset.submitting = true;
          submit_insurance_cta.disabled = true;
          
          /*if(this.checkValidity()){
            if (this.validateRut( $("#rut").val() )){
                $('.checkRut').hide();
        		$('#rut').css('border','1px solid #DEE2E5');
                this.setDataInsu(submit_insurance_cta);
                this.element.dataset.submitting = true;
                submit_insurance_cta.disabled = true;
        	} else {
        		$('#rut').css('border','1px solid red');
                $('.checkRut').show();
        	}
            
          }*/
        });
      }

      const insurance_dropwdown = this.element.querySelector(
        ".insurance-question"
      );
      if (insurance_dropwdown) {
        insurance_dropwdown.addEventListener("click", () => {
          const collapsed = !this.collapsed;
          this.collapsed = collapsed;
          this.element.dataset.collapsed = collapsed;
        });
      }

      const animate_dropdown = this.element.querySelector(
        ".insurance-question"
      );
      const insuranceChoices = this.element.querySelector(
        ".insurance-choices"
      );
      if (animate_dropdown) {
        animate_dropdown.addEventListener("click", () => {
          insuranceChoices.classList.toggle('transition');
          insuranceChoices.dataset.collapsed = insuranceChoices.classList.contains('transition') ? 'false' : 'true';
        });
      };

      // Dropdown automático si el seguro fue añadido
      document.addEventListener('DOMContentLoaded', () => {
        const insuranceProducts = document.querySelectorAll('.insurance-product');
        
        insuranceProducts.forEach(product => {
            const selectedInsuranceDiv = product.querySelector('.selected_insurance');
            
            if (selectedInsuranceDiv) {
                product.setAttribute('data-collapsed', 'false');
            }
        });
    });
    $('.coverage-trigger-js').on('click', function() {
        createIApp.modalCoverage.show()
      });
    $('a.read-more').on('click', function (e) {
      e.preventDefault();
      const $link = $(this);
      const $coverageInfo = $link.closest('.insurance').find('.coverage-info');
  
      const $chevron = $link.find('svg');
      
      if ($coverageInfo.hasClass('d-none')) {
        $coverageInfo.removeClass('d-none').hide();
      }
  
      if ($coverageInfo.is(':animated')) return;
  
      $coverageInfo.slideToggle(300, function () {
        const isVisible = $coverageInfo.is(':visible');
        
        if (isVisible) {
          $chevron.removeClass('bi-chevron-right').addClass('bi-chevron-up');
          $link.html('Ver menos <svg class="bi bi-chevron-up"fill=currentColor height=16 viewBox="0 0 16 16"width=16 xmlns=http://www.w3.org/2000/svg><path d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"fill-rule=evenodd /></svg>');
        } else {
          $chevron.removeClass('bi-chevron-up').addClass('bi-chevron-right');
          $link.html('Saber más <svg class="bi bi-chevron-right"fill=currentColor height=16 viewBox="0 0 16 16"width=16 xmlns=http://www.w3.org/2000/svg><path d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"fill-rule=evenodd /></svg>');
        }
      });
    });
    },
    addToCart: async function (formData) {
      console.log("formData ==>", formData);

      return fetch(window.Shopify.routes.root + this.url.addCart, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
    },
  };
}

const insurance_products = document.querySelectorAll(".insurance-product");
console.log('insurance_products =>', insurance_products);
if (insurance_products) {
  insurance_products.forEach((productEl) => {
    console.log('productEl =>', productEl);
    const newApp = createIApp();
    newApp.init(productEl.dataset.productId, productEl);
  });
}
console.log('nicolas')

function getCartData() {
    return new Promise((resolve, reject) => {
        $.getJSON('/cart.js').done(function(response) {
                if (response.attributes.Insurance !== undefined) {
                    const cartData = response.attributes.Insurance.split(',');
                    resolve(cartData);
                } else {
                    reject("No hay datos de seguro en el carrito.");
                }
            })
            .fail(function(jqxhr, textStatus, error) {
                var err = textStatus + ", " + error;
                reject("La solicitud falló: " + err);
            });
    });
};

async function removeCartAttr(cartAttr, url) {
    await getCartData()
        .then(data => {
            const index = data.indexOf(cartAttr);
            if (index !== -1) {
                data.splice(index, 1);
              
                console.log("nuevo data", data);
               const insuranceValue = data.join('-');
                let datosAttr
                if(insuranceValue === ''){
                  datosAttr = { 'attributes': { 'Insurance': '', 'insurance_rut': '', 'insurance_rut_type': '', 'insurance_fnac': '', 'insurance_cp': '', 'insurance_token': '' } }
                }else{
                  datosAttr = { 'attributes': { 'Insurance': insuranceValue } };
                }
                $.post('/cart/update.js', datosAttr).always(function() { location.href = url; });
            } else {
                console.log("cartAttr no existe");
            }
        })
        .catch(error => {
            console.error("Error:", error);
            return false;
            
        });
  location.href = url
}

function updateToZero(updates, url, cartAttr) {
    fetch(
            '/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    updates
                })
            })
        .then(response => {
            removeCartAttr(cartAttr,url);
          
        })
        .catch((error) => {
            location.href = url;
            console.error('Error al intentar quitar los productos al carro:', error);
        });
};

function removeInsurance(variantId) {
    const url = '/cart';
    getCartData().then(data => {
            const checkCartAttr = data.find(function(attributes) {
                return attributes.includes(variantId);
            });
            console.log("checkCartAttr: " + checkCartAttr);
            if (checkCartAttr) {
                console.log("Seguro encontrado en: " + checkCartAttr);
                var parts = checkCartAttr.split("-");
                var insuranceId = parts[1];
                console.log("Insurance id asociado al producto: " + insuranceId);

                updateToZero({
                    [Number(insuranceId)]: 0,
                    [Number(variantId)]: 0
                }, url, checkCartAttr)

            } else {
                console.log("No se encontró un seguro asociado.");
               updateToZero({
                    [Number(variantId)]: 0
                }, url);
            }
        })
        .catch(error => {
            updateToZero({
                [Number(variantId)]: 0
            }, url)
            console.error("Error:", error);
        });
    return false
};


function removeTradeIn(variantId) {

  console.log( "variantId ===>", variantId);
  fetch('/cart/update.js', {
  method: 'POST',
  body: JSON.stringify({
    attributes: { tradein_device_id: '', tradein_imei: '', tradein_value: '', tradein_variant_id: ''}
  }),
  headers: {
    'Content-Type': 'application/json'
  }
})
.then(async response => {



  
  const data =  await fetch('/cart.js').then(response => response.json())
  console.log('data:', data);
  let cartData = []
  if (data.attributes.Insurance !== undefined) {
      cartData = data.attributes.Insurance.split(',');
  }
  console.log('cartData:', cartData);
  const checkCartAttr = cartData.find(function(attributes) { return attributes.includes(variantId); });
  console.log('checkCartAttr:', checkCartAttr);
  let objUpdate = { updates: { [variantId]: 0 } };
  if (checkCartAttr){
    var insuranceId = checkCartAttr.split("-")[1];
    objUpdate = { updates: { [variantId]: 0, [insuranceId]: 0 } };
  }
  console.log('objUpdate:', objUpdate);
  
  fetch('cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: (variantId === 45063975076057) ? JSON.stringify({ updates: { 45063975076057: 0 } }) : JSON.stringify(objUpdate)
  })
  .then(response => {
    location.href = '/cart'
  })
  .catch((error) => {
    console.error('Error:', error);
  });
  
})
.catch(error => {
  console.error('Error:', error);
});
  
}
